import React, { useEffect, useState } from 'react';
import { useLanguageUtm } from '../Common';
import usePageTitle from '../Common/Hooks/usePageTitle';
import env from '../env';
import { usePartnerSamsungParams } from './utils';
import PostActivationPage from './PostActivationPage/PostActivationPage';

const SamsungActivation: React.FC = () => {
  usePartnerSamsungParams();
  useLanguageUtm();
  usePageTitle();

  return <PostActivationPage />;
};

export default SamsungActivation;
